import Control from "./Control.js"

export default class ListItem extends Control {

  constructor(props, context) {
    super(props, context)
    this.classList.add("amp-list-item")
    this.classList.remove("amp-icon")
    this.classList.remove("amp-control")
    this.state.direction = this.props.direction || "none"
  }

  static get contextTypes() {
    return super.contextTypes
  }

  focus() {
    this.refs.element.focus()
  }

  onKeyDown(event) {
    if (this.mouseFocus == true)
      return
    this.onKeyPress(event)
    if (event.type == "keydown") {
      //13, 32 space Enter
      //37, 39 left and right arrow
      //38, 40 up down
      switch (event.keyCode) {
        case 13:
        case 32:
          this.props.onClick(event) || this.onClick(event)
          break
        case 37:
          if (this.state.direction === "left")
            this.props.onClick(event) || this.onClick(event)
          break
        case 39:
        if (this.state.direction === "right")
          this.props.onClick(event) || this.onClick(event)
          break
        case 38:
          this.element.previousElementSibling !== null && this.element.previousElementSibling.focus()
          break
        case 40:
          this.element.nextElementSibling !== null && this.element.nextElementSibling.focus()
          break
      }

      if ( ((event.keyCode == 9 || event.keyCode == 40) && (event.shiftKey == false) && this.element.nextElementSibling === null) ||
           ((event.keyCode == 9 || event.keyCode == 38) && (event.shiftKey == true) && this.element.previousElementSibling === null) ||
             event.keyCode == 27 ) {
        let tabIndex
        if(this.refs.element.parentNode.className.indexOf("share") >=0 ) {
          tabIndex = 4
          this.plugin.refs.sharePanel.close()
        }
        else {
          tabIndex = 2
          this.plugin.refs.settingsPanel.close()
        }
        let tabable = document.getElementsByClassName("amp-control")
        setTimeout(() => { tabable[tabable.length - tabIndex].focus() }, 1);
      }

    }

    event.stopPropagation()
  }


  render() {
    return (
      <div ref="element" {...this.propsList} role="menuitem">
        {this.children}
      </div>
    )
  }

}
